<div class="relative mx-auto max-w-[1920px]">
    @if (videoUrl(); as url) {
        <ui-m000-c050-video [videoUrl]="url" />
    } @else {
        <ui-m000-c010-image
            class="image-hover block h-full"
            [image]="{
                image: image().url,
                desktop: { width: 1920, height: 600 },
                tablet: { width: 1022, height: 425 },
                mobile: { width: 767, height: 649 },
            }"
            [priority]="isFirstView()"
            [alt]="image().alt || ''"
            classList="h-full w-full aspect-[767/649] md:aspect-[1022/425] lg:aspect-[1920/600] object-cover"
            cover
            highRes
        />
    }
    <div class="from-black-70 absolute bottom-0 left-0 hidden h-[250px] w-full bg-gradient-to-t md:block"></div>

    <div class="inner-page-wrapper absolute inset-0 flex w-full flex-col justify-between py-24 lg:pt-64 lg:pb-[50px]">
        <div class="flex justify-between">
            <div class="flex flex-col gap-10 md:flex-row">
                <ui-m040-c030-badge type="blue">
                    {{ isAvailable() ? 'Sofort verfügbar' : 'Bei uns bestellbar' }}
                </ui-m040-c030-badge>
            </div>

            @if (logoImages(); as images) {
                <div class="flex flex-col gap-16">
                    @for (item of images; track item.url) {
                        <ui-m000-c010-image
                            class="block h-full"
                            [image]="{
                                image: item.url,
                                desktop: { width: 290 },
                                tablet: { width: 290 },
                                mobile: { width: 145 },
                            }"
                            [priority]="isFirstView()"
                            [alt]="item.alt || 'Logo'"
                            ignoreHeight
                            cover
                        />
                    }
                </div>
            }
        </div>
        <div class="flex flex-col justify-between gap-24 md:flex-row md:items-end">
            <div class="max-w-[1000px]">
                @if (title()) {
                    <h1 class="text-31 leading-36 text-white lg:text-[74px] lg:leading-78">
                        {{ title() }}
                    </h1>
                }
                @if (text(); as text) {
                    <p class="font-headline text-16 lg:text-22 leading-28 font-medium text-white">{{ text }}</p>
                }
            </div>
            <div class="flex w-full flex-col items-end empty:hidden md:w-auto">
                <ng-content select="[extras]" />
            </div>
        </div>
    </div>
</div>
